import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 9.8rem 0 9.8rem 0;

  .content_wrapper {
    display: flex;
    gap: 1rem;
    padding: 1.5rem;
    align-items: center;
    background: #D9F7FF;
    justify-content: center;
  }

  .left {
    align-self: flex-start;
  }

  .right {

    h1 {
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
      color: #004A80;
    }

    p {
      color: #004A80;
      font-size: 19px;
      font-style: normal;
      font-weight: 400;
      line-height: 130%
    }

    p:nth-child(3) {
      margin: 0 0 1rem 0;
    }

    strong {
      color: #004A80;
      font-size: 19px;
      font-weight: 700;
      line-height: 130%;
      font-style: normal;
    }
  }
`;